export default __webpack_public_path__ + "static/media/color-picker.f4f249bb.svg";